import { render, staticRenderFns } from "./gym-exchange-betterwe-token.vue?vue&type=template&id=0373f7e9&scoped=true&"
import script from "./gym-exchange-betterwe-token.vue?vue&type=script&lang=js&"
export * from "./gym-exchange-betterwe-token.vue?vue&type=script&lang=js&"
import style0 from "./gym-exchange-betterwe-token.vue?vue&type=style&index=0&id=0373f7e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373f7e9",
  null
  
)

export default component.exports